<div class="flex flex-column w-100">
  <div class="box-body table-responsive white" [formGroup]="filterFormGroup">
    <gp-table class="table table-striped">
      <colgroup>
        <col class="w"><!-- TYPE -->
        <col><!-- DETAILS -->
        <col><!-- REQUESTER -->
        <col><!-- SUBJECT -->
        <col class="w"><!-- STATUS -->
        <col><!-- ASSIGNEE -->
        <col class="w-sm"><!-- CREATION DATE -->
        <col class="w-sm"><!-- FINISH DATE -->
      </colgroup>
      <thead class="workflow-table">
      <tr role="heading">
        <th colspan="8" scope="row">
          <div class="pull-right p-a-xs">
            <button (click)="resetFilters()"
                    [disabled]="!filterFormGroup.dirty"
                    class="btn btn-xs btn-outline-primary"
                    test-id="clear-all-filters"
                    type="button">
              <em class="fa fa-light fa-filter-circle-xmark"></em>
              <span class="m-l-xs">{{'CONTEXT_BAR.clear_all_filters' | translate}}</span>
            </button>
          </div>
        </th>
      </tr>
      <tr role="heading">
        <th class="text-uppercase va-baseline" gp-table-column scope="col"
            test-id="type-header">{{ 'WORKFLOWS.type' | translate }}</th>
        <th class="text-uppercase va-baseline" gp-table-column scope="col"
            test-id="details-header">{{ 'WORKFLOWS.details' | translate }}</th>
        <th class="text-uppercase va-baseline" gp-table-column scope="col"
            test-id="requester-header">{{ 'WORKFLOWS.requester' | translate }}</th>
        <th class="text-uppercase va-baseline" gp-table-column scope="col"
            test-id="subject-header">{{ 'WORKFLOWS.subject' | translate }}</th>
        <th class="text-uppercase va-baseline" gp-table-column scope="col"
            test-id="status-header">{{ 'WORKFLOWS.status' | translate }}</th>
        <th class="text-uppercase min-width-sm va-baseline" gp-table-column scope="col"
            test-id="assignee-header">{{ 'WORKFLOWS.assignee' | translate }}</th>
        <th class="text-uppercase min-width-xs va-baseline" gp-table-column scope="col"
            test-id="creationDate-header">{{ 'WORKFLOWS.creationDate' | translate }}</th>
        <th class="text-uppercase min-width-xs va-baseline" gp-table-column scope="col"
            test-id="finishDate-header">{{ 'WORKFLOWS.finishDate' | translate }}</th>
      </tr>
      <tr role="heading">
        <td>
          <ng-select [attr.test-id]="'type-filter'"
                     [idField]="'key'"
                     [textField]="'key'"
                     [items]="workflowTypes"
                     [placeholder]="'WORKFLOWS.type' | translate "
                     class="form-control"
                     formControlName="type"
                     ngDefaultControl
          >
          </ng-select>
        </td>
        <td><!-- DETAILS --></td>
        <td><!-- REQUESTER --></td>
        <td>
          <input [attr.test-id]="'subject-filter'"
                 class="form-control"
                 formControlName="subject"
                 placeholder="{{'WORKFLOWS.subject' | translate}}"
                 type="text">
        </td>
        <td>
          <ng-select [attr.test-id]="'status-filter'"
                     [idField]="'key'"
                     [textField]="'name'"
                     [items]="WORKFLOW_STATUS"
                     [placeholder]="'WORKFLOWS.status' | translate "
                     class="form-control"
                     formControlName="status"
                     ngDefaultControl
          >
          </ng-select>
        </td>
        <td><input [attr.test-id]="'assignee-filter'"
                   class="form-control"
                   formControlName="assignee"
                   placeholder="{{'WORKFLOWS.assignee' | translate}}"
                   type="text"></td>
        <td><!-- CREATION DATE --></td>
        <td><!-- FINISH DATE --></td>
      </tr>
      </thead>
      <tbody class="fade-in-right">
      <tr *ngIf="loading">
        <td colspan="8" class="text-center">
          <div class="skeleton-block">
            <p>
              <skeleton-block width="100%" height="30px" [effect]="'wave'" borderRadius="4"></skeleton-block>
            </p>
            <p>
              <skeleton-block width="100%" height="30px" [effect]="'wave'" borderRadius="4"></skeleton-block>
            </p>
            <p>
              <skeleton-block width="100%" height="30px" [effect]="'wave'" borderRadius="4"></skeleton-block>
            </p>
          </div>
        </td>
      </tr>
      <tr *ngIf="!loading && !requests?.length">
        <td colspan="8" class="text-center p-t-lg p-b-lg">
          <gp-illustrated-message [text]="'WORKFLOWS.requests_not_found'" [width]="'60%'"></gp-illustrated-message>
        </td>
      </tr>
      <ng-container *ngIf="!loading && requests?.length">
        <tr *ngFor="let request of requests"
        >
          <td test-id="request-type">{{request?.type | translate}}</td>
          <td test-id="request-details">{{request.details ? (request.details | translate) : '-'}}</td>
          <td>
            <div>
              <span [attr.test-id]="'requester-full-name'">{{request?.requester?.fullName}}</span>
              <span *ngIf="request?.requester?.employeeNumber" [attr.test-id]="'requester-employee-number'"
                    class="text-muted">&nbsp;({{request?.requester?.employeeNumber}})</span>
            </div>
          </td>
          <td>
            <div>
                <span
                  [attr.test-id]="'subject-full-name'">{{request?.subject?.fullName ? request?.subject?.fullName : '-'}}</span>
              <span *ngIf="request?.subject?.employeeNumber"
                    [attr.test-id]="'subject-employee-number'"
                    class="text-muted">&nbsp;({{request?.subject?.employeeNumber}})</span>
            </div>
          </td>
          <td>
            <gp-workflow-status [status]="request.status"></gp-workflow-status>
          </td>
          <td>
            <ng-container *ngIf="request?.assignee else noAssignee">
              <div>
                <span [attr.test-id]="'assignee-full-name'">{{request?.assignee?.fullName}}</span>
                <span *ngIf="request?.assignee?.employeeNumber"
                      [attr.test-id]="'assignee-employee-number'"
                      class="text-muted">&nbsp;({{request?.assignee?.employeeNumber}})</span>
              </div>
            </ng-container>
            <ng-template #noAssignee>
              <ng-container *ngIf="request?.candidates?.length else noCandidates">
                <div *ngFor="let candidate of request?.candidates; let index = index">
                  <span [attr.test-id]="'candidate-' + index + '-full-name'">{{candidate?.fullName}}</span>
                  <span *ngIf="candidate?.employeeNumber"
                        [attr.test-id]="'candidate-' + index + '-employee-number'"
                        class="text-muted">&nbsp;({{candidate?.employeeNumber}})</span>
                </div>
              </ng-container>
            </ng-template>
            <ng-template #noCandidates>
              <div>-</div>
            </ng-template>
          </td>
          <td test-id="request-start-time">{{request?.startTime | gpDate: {withHour: true}: (trigger$|async)}}</td>
          <td test-id="request-end-time">{{request?.endTime | gpDate: {withHour: true}: (trigger$|async)}}</td>
        </tr>
      </ng-container>
      </tbody>
    </gp-table>
  </div>
  <gp-table-pagination
    (pageChange)="refreshRequests()"
    [pagination]="pagination"
    [text]="'WORKFLOWS.showing___of_tasks'">
  </gp-table-pagination>
</div>


